import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
i18n
    .use(HttpBackend) // Permite cargar las traducciones desde un servidor
    .use(LanguageDetector)
    .use(initReactI18next) // Pasar i18n a react-i18next
    .init({
        fallbackLng: 'en',
        supportedLngs: ['es', 'en'], // Idiomas soportados
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // react ya se encarga de la seguridad contra XSS
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Ruta para cargar las traducciones
        },
    });

export default i18n;
